import { EORDER_STATUS } from "@constants";
import { Theme } from "@mui/material";

export const getOrderStatusColor = (orderStatus: EORDER_STATUS, theme: Theme) => {
    switch (orderStatus) {
        case EORDER_STATUS.IN_PROGRESS:
            return theme.palette.primary.main;
        case EORDER_STATUS.COMPLETED:
            return theme.palette.success.dark;
        default:
            return theme.palette.warning.main;
    }
};

export const MONTH_INTERVAL_LIST = [3, 6, 12];
